import React from 'react'

const Dummy = () => {
  return (
    <div>Dummy</div>
  )
}
export default Dummy